import { RIBBON_ON_CHANGE_EVENT } from './constants'

export function ribbonOnChange(module, component, item) {
    return {
        type: RIBBON_ON_CHANGE_EVENT,
        data: {
            module,
            component,
            item,
        },
    }
}
